import { render, staticRenderFns } from "./PalletLabelPopup.vue?vue&type=template&id=2260058e"
import script from "./PalletLabelPopup.vue?vue&type=script&lang=js"
export * from "./PalletLabelPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports